'use client';

import { Box, Typography } from '@mui/material';

interface TitleProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  underline?: boolean;
  underlineColor?: string;
  underlineHeight?: number;
  centered?: boolean;
  gutterBottom?: boolean;
  [key: string]: any;
}

const Title = ({
  children,
  level = 1,
  underline = true,
  underlineColor = '#EB722E',
  underlineHeight,
  centered = false,
  gutterBottom = true,
  ...props
}: TitleProps) => {
  const variantMap = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6',
  };

  const underlineHeightMap = {
    1: 6,
    2: 5,
    3: 4,
    4: 3,
    5: 2,
    6: 2,
  };

  const finalUnderlineHeight = underlineHeight ?? underlineHeightMap[level];

  return (
    <Box
      display='inline-flex'
      flexDirection='column'
      alignItems={centered ? 'center' : 'flex-start'}
      mb={gutterBottom ? 2 : 0}
      sx={{
        '&:hover .underline': {
          width: '100%',
        },
        '&:hover .title-text': {
          transform: 'scale(1.05)',
        },
      }}
    >
      <Typography
        variant={variantMap[level] as any}
        component={variantMap[level] as any}
        className='title-text'
        fontWeight='bold'
        sx={{
          transition: 'transform 0.3s ease',
          cursor: 'default',
        }}
        {...props}
      >
        {children}
      </Typography>

      {underline && (
        <Box
          className='underline'
          sx={{
            height: finalUnderlineHeight,
            width: '50%',
            backgroundColor: underlineColor,
            borderRadius: finalUnderlineHeight / 2,
            mt: 0.5,
            transition: 'width 0.4s ease-out',
            mx: centered ? 'auto' : 0,
          }}
        />
      )}
    </Box>
  );
};

export default Title;
